/** Generated by scripts/generate-support-assistant-published-spans.ts. */
export const PUBLISHED_HELP_SAFE_SPANS: readonly string[] = [
  'actions tab',
  'active view',
  'add allergy',
  'add field',
  'aged care provider portal',
  'allergy register',
  'allergy register section',
  'annual care plan',
  'api tests',
  'assign form',
  'attention view',
  'audit program workspace',
  'awaiting onboarding',
  'beds tab',
  'behaviour support plan',
  'behaviour support plans',
  'billing run',
  'billing view',
  'budget tab',
  'budget workspace',
  'bulk agency worker onboarding',
  'calendar from the compliance sidebar',
  'cancel draft',
  'care incident register report',
  'care plan',
  'care plans',
  'care worker app',
  'chart view',
  'checklist section',
  'chsp care plan',
  'chsp finance panel',
  'chsp invoice details',
  'chsp panel',
  'chsp portal',
  'client allergy',
  'client allergy register',
  'client button',
  'client care plans',
  'client care plans tab',
  'client delivery tab',
  'client details',
  'client details tab',
  'client documents tab',
  'client form',
  'client funding tab',
  'client healthcare identifier panel',
  'client ids',
  'client ihi',
  'client incidents tab',
  'client journey',
  'client list',
  'client medication tab',
  'client medications view',
  'client name',
  'client panel',
  'client plan',
  'client portal',
  'client profile',
  'client record',
  'client record overview',
  'client register',
  'client statement',
  'client statements',
  'clients register',
  'clinical tab',
  'clock in',
  'clock out',
  'close screen',
  'code of conduct report',
  'compliance register',
  'compliance statements',
  'compliance tab',
  'compliance view',
  'conduct review dialog',
  'contact register',
  'corrections tab',
  'create care plan',
  'create draft',
  'current resident beds',
  'dashboard library overview',
  'delivery tab',
  'document field',
  'documents panel',
  'documents tab',
  'edit details',
  'edit details dialog',
  'edit dialog',
  'edit draft',
  'evidence overview',
  'evidence register',
  'exceptions button',
  'exceptions list',
  'existing draft',
  'existing rac workspace',
  'export tab',
  'facility operations view',
  'falls summary and the incident register',
  'family app',
  'family portal',
  'feedback tab',
  'filter plan',
  'finance open a worker record',
  'funding overview',
  'funding tab',
  'generate draft',
  'healthcare identifier panel',
  'hr officer review screening',
  'in plan',
  'in statements',
  'incidents tab',
  'infection control',
  'invoice run',
  'invoice statements',
  'invoices list',
  'journey tab',
  'learning panel',
  'medication incident register',
  'medications tab',
  'medications view',
  'medications workspace',
  'monthly metrics and the overview',
  'monthly statements',
  'my onboarding',
  'my onboarding journey',
  'my organisation runs',
  'my profile',
  'ndis billing and participant statements',
  'ndis incident and record',
  'ndis participant statement',
  'ndis registration plan draft',
  'no care plan',
  'notification panel',
  'occupancy view',
  'on the mobile app',
  'open care plan',
  'open draft',
  'open form',
  'open plan',
  'open the metrics panel',
  'organisation details',
  'overview tab',
  'palliative plans',
  'participant journey',
  'participant list',
  'participant statement',
  'participant statements',
  'pay profile',
  'pay run',
  'pay runs',
  'pay view',
  'payroll profile',
  'payroll workspace',
  'payroll workspace overview',
  'people register',
  'people tab',
  'people workspace',
  'policy list',
  'prepare and review the statement',
  'prepare tab',
  'print dialog',
  'print list',
  'provider portal',
  'public form',
  'publish button',
  'publish drawer',
  'rac workspace',
  'readiness on overview',
  'readiness overview',
  'recipients tab',
  'recording an allergy',
  'reference data section',
  'reports tab',
  'resident beds',
  'resident list',
  'resident profile',
  'resident statement',
  'resident statements',
  'residential tab',
  'residential workspace',
  'review and record',
  'review button',
  'review draft',
  'review section',
  'roster section',
  'save button',
  'save draft',
  'saved timing in the care worker app',
  'screening overview',
  'screening register',
  'screening section',
  'search field',
  'select client screen',
  'service delivery workspace',
  'services australia',
  'services australia invoices tab',
  'services australia panel',
  'services tab',
  'settings control',
  'staff compliance report',
  'staff list',
  'staff profile',
  'staff register',
  'staff view',
  'statements client list',
  'statements workspace',
  'statura or record',
  'support plan',
  'support plans',
  'support portal',
  'task workflow overview',
  'tasks drawer',
  'tasks workspace',
  'team availability register',
  'the allergy',
  'the button',
  'the chsp panel',
  'the clients register',
  'the close section',
  'the create invoice dialog',
  'the dialog',
  'the draft',
  'the drawer',
  'the exceptions button',
  'the exceptions list',
  'the form',
  'the list',
  'the panel',
  'the plan',
  'the register',
  'the requests tab',
  'the requests view',
  'the screen',
  'the section',
  'the sidebar',
  'the timesheets screen',
  'the view',
  'the workspace',
  'the workstation',
  'the xero draft',
  'timesheets tab',
  'to register',
  'unavailable readiness details',
  'use document field',
  'use plan',
  'use record',
  'use the incident workspace',
  'use the whs register',
  'visit runs',
  'whs field',
  'whs form',
  'whs incident draft',
  'whs incident form',
  'whs incident register or report',
  'whs incidents list',
  'whs register',
  'whs report',
  'worker app',
  'worker drawer',
  'worker field',
  'worker hpi-i',
  'worker list',
  'worker onboarding',
  'worker pay',
  'worker profile',
  'worker queries register',
  'worker record',
  'worker register',
  'worker screen',
  'worker screening',
  'worker screening enforcement',
  'worker screening register',
  'worker view',
  'workers tab',
  'workers view',
  'workflow panel',
  'workforce operations view',
  'wounds tab',
  'xero draft',
  'xero employee details',
  'xero loading and record',
  'xero me',
  'xero panel',
  'xero plan',
  'your draft',
  'your screen',
  'your view',
];
